export default __webpack_public_path__ + "static/media/nasa-insta.33c6b0b9.webp";